const STORAGE_KEY = 'la_anon_id_v1';

/** This device ID belongs only to our usage ledger. Never pass it to GA. */
export function getAnonId(): string | null {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && /^[0-9a-f-]{36}$/.test(stored)) return stored;
    const id = crypto.randomUUID();
    localStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    // A transient ID would inflate the identity count every visit. When
    // storage is blocked, signed-in telemetry can still use the user ID.
    return null;
  }
}
